import { classNames } from 'tradera/utils/class-names';
import React from 'react';

import { LazyImageLoader } from './image-lazy-load';

export type ImageLoaderProps = {
    src: string;
    fallback?: React.ReactNode;
    /**
     * This can be used to force a loading state
     */
    forceLoadingState?: boolean;
    className?: string;
    loadingClassName?: string;
    alt?: string;
};

enum ImageLoaderState {
    PENDING = 'pending',
    LOADED = 'loaded',
    ERROR = 'error'
}

export const ImageLoader = ({
    src,
    fallback,
    forceLoadingState,
    className,
    loadingClassName = '',
    ...otherProps
}: ImageLoaderProps) => {
    const [state, setState] = React.useState<ImageLoaderState>(
        ImageLoaderState.PENDING
    );

    const onLoad = () => setState(ImageLoaderState.LOADED);
    const onError = () => setState(ImageLoaderState.ERROR);

    if (
        state === ImageLoaderState.PENDING ||
        state === ImageLoaderState.LOADED ||
        forceLoadingState
    ) {
        return (
            <LazyImageLoader
                className={classNames(
                    {
                        [loadingClassName]:
                            state === ImageLoaderState.PENDING ||
                            forceLoadingState
                    },
                    className
                )}
                src={src}
                onLoad={onLoad}
                onError={onError}
                {...otherProps}
            />
        );
    }
    // state === ImageLoaderState.ERROR
    return <>{fallback}</> ?? null;
};
